import { useApp } from '../../app/AppContext';
import { useStore } from '../../app/StoreContext';
import { MediaLibrary } from '../../components/MediaLibrary';

export function AdminMedia() {
  const { reload } = useApp();
  const { reloadStore } = useStore();
  return (
    <div>
      <h1>Media library</h1>
      <p className="muted">Photos from your website and menu, plus anything you upload. Pick one as your logo, or use them on menu items.</p>
      <MediaLibrary mode="manage" onProfileChanged={() => { void reload(); void reloadStore(); }} />
    </div>
  );
}
